'use strict';
/**
 * @author Maxim Seredkin
 */


export default function () {
    return {
        restrict: 'A',
        template: require('../view/support-filter.html'),
        transclude: true,
        scope: {
            types: '=types',
            okveds: '=okveds',
            areases: '=areases',
            operators: '=operators',
            applyFilter: '=applyFilter',
        },
        controller: ['$scope', 'SupportFilterService', 'OperatorService', '$rootScope', '$utils',
            function ($scope, SupportFilterService, OperatorService, $rootScope, $utils) {

                $scope.localFilters = SupportFilterService.getFilters();
                $scope.getOperatorDisplayName = OperatorService.getDisplayName;
                $scope.isBetween = OperatorService.isBetween;
                $scope.selectSettings = { ...$rootScope.selectSettings };

                $scope.closeFilter = () => {
                    $scope.localFilters = SupportFilterService.getFilters();
                    $utils.openControlSidebar();
                }

                $scope.reset = () => {
                    $scope.localFilters = SupportFilterService.getDefaultFilters();
                    $scope.filterForm.$setPristine();
                }

                $scope.ok = (filters) => {
                    $utils.openControlSidebar();
                    $scope.applyFilter(filters);
                }
            }]
    };
}
